import React from "react";

const Actions = ({ label, actions, variant = "outlined", body }) => {
  return (
    <div
      className={`actions__amellis ${variant ? `actions__amellis--${variant}` : ""}`}
    >
      <div className="actions__amellis--head">
        <div className="actions__amellis--left">
          <span dangerouslySetInnerHTML={{ __html: label }}></span>
        </div>
        <div className="actions__amellis--right">
          <div className="d-flex">{actions}</div>
        </div>
      </div>
      {body && <div className="actions__amellis--body"> {body} </div>}
    </div>
  );
};

export default Actions;
